// Sample data for the Usage page's charts, which have no Consumer API route
// behind them yet. Every use of it is labelled as sample data. See Design >
// Console, "What is real".

export type Sample = {
  sample: true;
  usageDays: number[];
  history: { type: "Top off" | "Charge" | "Refund"; what: string; hub: string | null; amount: number; daysAgo: number }[];
  breakdown: { label: string; answers: number }[];
};

export const SAMPLE: Sample = {
  "sample": true,
  "usageDays": [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    5,
    2,
    12,
    40,
    18,
    6,
    4,
    2,
    1,
    0,
    0,
    5,
    3,
    2,
    9,
    2,
    1,
    1,
    0,
    1,
    2,
    1
  ],
  "history": [
    {
      "type": "Top off",
      "what": "Credits added",
      "hub": null,
      "amount": 10.0,
      "daysAgo": 21
    },
    {
      "type": "Charge",
      "what": "Sample answer",
      "hub": "[hub]",
      "amount": -0.0002,
      "daysAgo": 3
    },
    {
      "type": "Refund",
      "what": "Sample refund",
      "hub": "[hub]",
      "amount": 0.0002,
      "daysAgo": 3
    }
  ],
  "breakdown": [
    {
      "label": "[hub 1]",
      "answers": 30
    },
    {
      "label": "[hub 2]",
      "answers": 14
    },
    {
      "label": "[hub 3]",
      "answers": 4
    }
  ]
};
